import { ChildrenElement } from "tm/utils";

import { trackUserActivity } from "@devforce/th-components/modules/common/track/track";

export type Feature = {
  ctaPrimaryHref: string;
  ctaPrimaryTitle: string;
  ctaPrimaryTarget: string;
  ctaSecondaryHref: string;
  ctaSecondaryTarget: string;
  ctaSecondaryTitle: string;
  description: string;
  imgAlt: string;
  imgSrc: string;
  title: string;
};

export default class extends ChildrenElement<Feature> {
  childTagName = "TM-GRID-ITEM";
  extractor = (element: Element) => {
    const ctaPrimaryTitle = element.getAttribute("cta-primary-title")!;
    const ctaSecondaryTitle = element.getAttribute("cta-secondary-title")!;

    return {
      ctaPrimaryHref: element.getAttribute("cta-primary-href")!,
      ctaPrimaryTarget: element.getAttribute("cta-primary-target") || "",
      ctaPrimaryTitle,
      ctaSecondaryHref: element.getAttribute("cta-secondary-href")!,
      ctaSecondaryTarget: element.getAttribute("cta-secondary-target") || "",
      ctaSecondaryTitle,
      description: element.getAttribute("description")!,
      imgAlt: element.getAttribute("img-alt")!,
      imgSrc: element.getAttribute("img-src")!,
      title: element.getAttribute("title")!,
      handlePrimaryCtaClick: this.handleCtaClick.bind(
        this,
        "primary",
        ctaPrimaryTitle
      ),
      handleSecondaryCtaClick: this.handleCtaClick.bind(
        this,
        "secondary",
        ctaSecondaryTitle
      ),
    };
  };

  handleCtaClick(ctaType: "primary" | "secondary", label: string) {
    trackUserActivity(this, "cta_clicked", {
      ctaType,
      label,
      pageLocation: "tm-feature-grid-a",
    });
  }
}
